import { useGroupByStore } from "../GroupByStoreProvider";
import { selectSelectedProduct } from "../groupBySelectors";
import useGroupedProductOptions from "./useGroupedProductOptions";

export const useProductSelect = () => {
  const selectedProduct = useGroupByStore(selectSelectedProduct);
  const setSelectedProduct = useGroupByStore((s) => s.setSelectedProduct);
  const productOptions = useGroupedProductOptions();

  return {
    selectedProduct,
    productOptions,
    onProductChange: setSelectedProduct
  };
};
